export const SELECT_DURATION = 'SELECT_DURATION_PHYSICAL_ACTIVITY';
export const SELECT_INTENSITY = 'SELECT_INTENSITY_PHYSICAL_ACTIVITY';
export const SELECT_TEMPERATURE = 'SELECT_TEMPERATURE_PHYSICAL_ACTIVITY';
export const DEFAULT = 'DEFAULT_PHYSICAL_ACTIVITY';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_PHYSICAL_ACTIVITY';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_PHYSICAL_ACTIVITY';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_PHYSICAL_ACTIVITY';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
